import { addToCart } from "@theme/utilities";

/**
 * Add items to cart from a link
 * Example: https://shop.bodi.com/cart?addItemsToCart={"items":[{"id":"1234567890","quantity":1}]}
 * @returns {Promise<void>}
 */
(async function AddToCartLinkUtilModule() {
  const currentUrl = new URL(window.location.href);
  
  const addToCartAction = JSON.parse(currentUrl.searchParams.get('addItemsToCart') || 'null');
  if (!addToCartAction) return;

  await addToCart(addToCartAction.items);

  // Delay redirect to allow tracking events (GTM, Amplitude) to fire
  await new Promise((resolve) => setTimeout(resolve, 2000));

  if (addToCartAction.redirectUrl) {
    window.location.href = addToCartAction.redirectUrl;
  } else {
    currentUrl.searchParams.delete('addItemsToCart');
    window.location.href = currentUrl.toString();
  }
})();
